import { Languages, ShieldCheck } from 'lucide-react';
import type { ReactNode } from 'react';
import { ProductMark } from '../../app/shell/ProductMark';
import { TestEnvStrip } from '../../app/shell/TestEnvStrip';
import { useI18n } from '../../i18n/I18nProvider';
import { Button } from '../../ui/Button';
import styles from './Auth.module.css';

/** Sign-in and registration frame: brand panel + form (stacks on small screens). */
export function AuthLayout({ children }: { children: ReactNode }) {
  const { t, locale, setLocale } = useI18n();
  return (
    <>
      <TestEnvStrip />
      <div className={styles.layout}>
        <aside className={styles.brandPanel} aria-label={t.app.name}>
          <div className={styles.brandMark}>
            <ProductMark size={36} />
            <span>{t.app.name}</span>
          </div>
          <p className={styles.brandHeadline}>{t.auth.brandHeadline}</p>
          <ul className={styles.points}>
            {t.auth.brandPoints.map((point) => (
              <li key={point}>
                <ShieldCheck size={18} aria-hidden="true" />
                <span>{point}</span>
              </li>
            ))}
          </ul>
        </aside>
        <main className={styles.formPanel} id="main">
          <div className={styles.formTop}>
            <Button
              variant="ghost"
              size="sm"
              icon={<Languages size={16} aria-hidden="true" />}
              onPress={() => setLocale(locale === 'ar' ? 'en' : 'ar')}
              aria-label={`${t.shell.switchLanguage} (${t.shell.otherLanguageName})`}
            >
              <span lang={locale === 'ar' ? 'en' : 'ar'}>{t.shell.otherLanguageName}</span>
            </Button>
          </div>
          <div className={styles.formWrap}>{children}</div>
        </main>
      </div>
    </>
  );
}

export const authStyles = styles;
